export default __webpack_public_path__ + "static/media/hp-404-page-img.5ccdbbc6.svg";